import { ADD_FILE, ADD_FILE_MESSAGE, ADD_MESSAGE, ADD_MESSAGE_LIST, SET_CHOICE_MEMBER, SET_IS_CHAT_READ, SET_IS_KEYBOARD_OPEN, SET_IS_LIVE, SWITCH_TO_LIVE_MESSAGE, } from './actionTypes';
import { checkChatPermission } from './functions';
/**
 * 메시지 전송
 * @param {String} message
 */
export function addMessage(message, local, isShared = false) {
    return {
        type: ADD_MESSAGE,
        message,
        local,
        isShared,
    };
}
export function updateMessage(messages, replaceUuid) {
    return {
        type: 'UPDATE_MESSAGE',
        messages,
        // 교체 대상(발신 시점 낙관적 항목의 클라이언트 시각 키) — 서버 확정 키와 다르면 삭제 후 삽입
        replaceUuid,
    };
}
/**
 * 메시지 전송
 * @param {String} message
 */
export function addMessageList(messages, total_count, last_message = null, isUp = false, isFirst) {
    return {
        type: ADD_MESSAGE_LIST,
        messages,
        total_count,
        last_message,
        isUp,
        isFirst,
    };
}
export function swithToLiveMessage() {
    return {
        type: SWITCH_TO_LIVE_MESSAGE,
    };
}
export function updateBeforeChat(lastItemId) {
    return {
        type: 'UPDATE_BEFORE_CHAT',
        lastItemId,
    };
}
export function updateAfterChat(startItemId) {
    return {
        type: 'UPDATE_AFTER_CHAT',
        startItemId,
    };
}
/**
 * 최신 페이지 재조회(교체) — 위로 페이징으로 윈도우가 슬라이드(최신쪽 폐기)된 뒤
 * 바닥 복귀 시, 이어붙이기 대신 서버 기준 최신으로 복원한다(중간 공백/최근 소실 방지).
 */
export function refetchLatestChat() {
    return {
        type: 'REFETCH_LATEST_CHAT',
    };
}
/**
 * 파일 전송
 * @param file
 * @param group_id
 * @returns
 */
export function addFileMessage(message, local, isShared = false) {
    return {
        type: ADD_FILE_MESSAGE,
        message,
        local,
        isShared,
    };
}
/**
 * 파일 저장
 * @param data
 * @param isRemote
 * @returns
 */
export function addShareFile(data, isRemote = true) {
    return async (dispatch, getState) => {
        if (!isRemote) {
            if (checkChatPermission(getState, 'chat')) {
                const response = await APP.management.sendFile(data);
                if (response.status !== 200) {
                    /**
                     * (fix me)
                     */
                    console.log('addShareFile - error');
                    return;
                }
            }
            else
                return;
        }
        dispatch({
            type: ADD_FILE,
            data,
        });
    };
}
/**
 * 메시지 저장
 * @param data
 * @param isRemote
 * @returns
 */
export function addShareMessage(data, isRemote = true) {
    return {
        type: ADD_MESSAGE,
        data,
        isRemote,
    };
}
/**
 * 채팅 전송할 사용자 설정
 * @param members
 * @returns
 */
export function setChoiceMember(members) {
    return {
        type: SET_CHOICE_MEMBER,
        members,
    };
}
/**
 * 채팅 read
 */
export function setIsChatRead(isRead) {
    return {
        type: SET_IS_CHAT_READ,
        isRead,
    };
}
export function removeChatList() {
    return {
        type: 'REMOVE_CHAT_LIST',
    };
}
export function setIsKeyboardOpen(isKeyboardOpen) {
    return {
        type: SET_IS_KEYBOARD_OPEN,
        isKeyboardOpen,
    };
}
export function setIsLive(isLive) {
    return {
        type: SET_IS_LIVE,
        isLive,
    };
}
